import axios from "../../core/axios";
import { EntityViewSet, Headers } from "../generic";
import type {
  NovelParagraphCreateImageParams,
  NovelParagraphCreateParams,
  NovelParagraphEntity,
  NovelParagraphListParams,
  Result,
} from "../../types";
import { assertSuccess, paramsParser } from "../../core";

export class NovelParagraph extends EntityViewSet<
  NovelParagraphListParams,
  NovelParagraphCreateParams,
  {},
  NovelParagraphEntity
> {
  constructor(
    path: string,
    public chapterId: string,
  ) {
    super(path + `/${chapterId}/paragraph`);
  }

  override async find(
    params: Partial<Omit<NovelParagraphListParams, "novelChapterId">> = {},
    auth?: string,
  ) {
    return super.find({ ...params, novelChapterId: this.chapterId }, auth);
  }

  override async create(
    body: Omit<NovelParagraphCreateParams, "novelChapterId">,
    auth: string,
  ) {
    return super.create({ ...body, novelChapterId: this.chapterId }, auth);
  }

  override async update(
    id: string,
    body: {},
    auth: string,
  ): Promise<NovelParagraphEntity> {
    throw new Error("Paragraphs are immutable");
  }

  async createImage(body: NovelParagraphCreateImageParams, auth: string) {
    const formData = new FormData();

    // field name is irrelevant
    formData.append("asagi_mutsuki", body.image);
    formData.append("altText", body.altText);

    // when doing image paragraphs, the param altText is json encoded and used as the value for the text attribute
    const resp = await axios.post<Result<NovelParagraphEntity>>(
      this.apiPath +
        "/image" +
        paramsParser({
          novelChapterRevisionId: body.novelChapterRevisionId,
        }),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          ...Headers.Bearer(auth),
        },
      },
    );

    return assertSuccess(resp.data).data;
  }
}
